module.exports = __webpack_public_path__ + "media/images/mamari/wowma/about-img-01-fa70ab0e98d7f2c2ffeb97c74026445a.png";